var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMapInactive = function SvgMapInactive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.364,
    transform: "translate(9 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.136C12 10.91 6 15 6 15s-6-4.09-6-8.864C0 2.747 2.686 0 6 0s6 2.747 6 6.136z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 6.136,
    rx: 2,
    ry: 2.045
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMapInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map-inactive.fa55a9e1a5b43f57f673a1768608c74b.svg";